import { useMemo } from 'react';

import { RootStateOrAny, useSelector } from 'react-redux';

import { ensureIsNumber } from '../../utils/ensureIsNumber';
import {
  allowExclusiveCheckout as allowExclusiveCheckoutSelector,
  getFreeShippingThreshold,
} from '../../utils/selectors';
import useGiftWithPurchase from '../../utils/useGiftWithPurchase';

import { useMemberFreeShipping } from './useFreeShipping';

export function useCartDrawerPromoProgressBar() {
  const {
    isGwpAvailable: isGwpAvailableBase,
    gwpMinSubtotal,
    shouldDisplayGwp,
    isGwpApplied,
  } = useGiftWithPurchase();
  const { subtotalMinusDiscount = 0 } = useSelector(
    ({ checkout }: RootStateOrAny) => checkout
  );

  const isGwpAvailable = isGwpApplied ? false : isGwpAvailableBase;
  const shouldShowProgressBar =
    isGwpAvailable && shouldDisplayGwp && Boolean(gwpMinSubtotal);
  return {
    shouldShowProgressBar,
    total: subtotalMinusDiscount,
    threshold: gwpMinSubtotal,
  };
}

export function useCartDrawerFreeShippingProgressBar() {
  const { subtotalMinusDiscount = 0 } = useSelector(
    (state: RootStateOrAny) => state.checkout
  );
  const hasMemberFreeShipping = useMemberFreeShipping();
  const allowExclusiveCheckout = useSelector(allowExclusiveCheckoutSelector);
  const freeShippingThreshold = useSelector(getFreeShippingThreshold);

  const shouldShowProgressBar =
    !hasMemberFreeShipping && !allowExclusiveCheckout;

  return useMemo(
    () => ({
      shouldShowProgressBar,
      total: ensureIsNumber(subtotalMinusDiscount),
      threshold: ensureIsNumber(freeShippingThreshold),
    }),
    [freeShippingThreshold, shouldShowProgressBar, subtotalMinusDiscount]
  );
}
